import { render, staticRenderFns } from "./MpcPledge.vue?vue&type=template&id=15ff77e8&scoped=true"
import script from "./MpcPledge.vue?vue&type=script&lang=js"
export * from "./MpcPledge.vue?vue&type=script&lang=js"
import style0 from "./MpcPledge.vue?vue&type=style&index=0&id=15ff77e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff77e8",
  null
  
)

export default component.exports